const SimarUI = () => {
  return (
    <div className="flex flex-wrap gap-8 mx-32 justify-center">
      {/* <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg"> */}
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
      <div className="max-w-xs mx-auto bg-white rounded-lg cursor-pointer overflow-hidden shadow-md hover:shadow-lg">
        <div className="skeleton h-[13rem] w-[14rem]" />

        <h2 className="sim-h2 skeleton"></h2>
        <br />

        <h4 className="sim-h4 skeleton"></h4>
        <br />
      </div>
    </div>
  );
};

export default SimarUI;
